"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DesignerSide;

var React = _interopRequireWildcard(require("react"));

var _usePkpass2 = require("../usePkpass");

var _reactJss = require("react-jss");

var _types = require("../../../../types");

var _Theme = require("../../Theme");

var _maskStyle;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _reactJss.createUseStyles)({
  root: {
    width: function width(_ref) {
      var theme = _ref.theme;
      return 320 * theme.scale;
    },
    height: function height(_ref2) {
      var theme = _ref2.theme;
      return 450 * theme.scale;
    },
    filter: 'drop-shadow(0px 11px 15px rgba(0, 0, 0, 0.2))'
  },
  svg: {
    position: 'absolute',
    width: function width(_ref3) {
      var theme = _ref3.theme;
      return 320 * theme.scale;
    },
    height: function height(_ref4) {
      var theme = _ref4.theme;
      return 450 * theme.scale;
    },
    left: 0
  }
});
var maskStyle = (_maskStyle = {}, _defineProperty(_maskStyle, _types.PkpassPassStyleTypes.BoardingPass, {
  mask: "url('#m-boarding')"
}), _defineProperty(_maskStyle, _types.PkpassPassStyleTypes.Coupon, {
  mask: "url('#m-coupon')"
}), _defineProperty(_maskStyle, _types.PkpassPassStyleTypes.EventTicket, {
  mask: "url('#m-ticket')"
}), _defineProperty(_maskStyle, _types.PkpassPassStyleTypes.Generic, {
  mask: "url('#m-round')"
}), _defineProperty(_maskStyle, _types.PkpassPassStyleTypes.StoreCard, {
  mask: "url('#m-round')"
}), _maskStyle);

function DesignerSide(props) {
  var children = props.children;

  var _usePkpass = (0, _usePkpass2.usePkpass)(),
      passStyle = _usePkpass.passStyle,
      pass = _usePkpass.pass;

  var theme = (0, _Theme.useTheme)();
  var classes = useStyles({
    theme: theme
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: passStyle
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 450",
    className: classes.svg
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h320v450H0z",
    style: {
      fill: pass.backgroundColor,
      mask: maskStyle[passStyle].mask
    }
  })), children));
}
//# sourceMappingURL=DesignerSide.js.map